import { SyntheticEvent } from 'react';
import { NAVIGATION_BUTTON_NAME } from '@portals/hc-rich-editor';
import { EHelpCenterType } from '@portals/help-center-core';
import { getElementParents } from '@/_analytic/_utils/get-element-parents';
import { getNameDataSetByElements } from '@/_analytic/events/article-content-click-event/_utils/get-name-data-set-by-elements';
import { articleContentNavigationButtonClickEvent } from '@/_analytic/events/article-content-navigation-button-click-event';
import { EArticleContentName } from '@/_analytic/events/article-content-click-event/_types';
import { articleContentLinkClickEvent } from '@/_analytic/events/article-content-link-click-event';
import { getIsTypeOfBlock } from '@/_analytic/events/article-content-click-event/_utils/get-is-type-of-block';
import { faqClickEvent } from '@/_analytic/events/faq-click-event';
import { drawerOpenFaqEvent } from '@/_analytic/events/drawer-open-faq';
import { TAnalyticEventParams } from '@/_analytic/_types';

type TProps = {
  idArticle: TAnalyticEventParams['idArticle'];
  articleName: TAnalyticEventParams['articleName'];
  helpCenterType: TAnalyticEventParams['helpCenterType'];
  sectionId: TAnalyticEventParams['sectionId'];
  sectionName: TAnalyticEventParams['sectionName'];
  subsectionName: TAnalyticEventParams['subsectionName'];
  subsectionId: TAnalyticEventParams['subsectionId'];
  url: TAnalyticEventParams['url'];
};

export const getArticleContentAnalyticHandler =
  ({
    idArticle,
    articleName,
    subsectionId,
    helpCenterType,
    sectionId,
    sectionName,
    subsectionName,
    url,
  }: TProps) =>
  (event: SyntheticEvent<HTMLElement>): void => {
    const target = event.target as HTMLElement;

    if (!articleName) {
      return;
    }

    const parents = getElementParents(target);
    const nameDataSet = getNameDataSetByElements([target, ...parents]);

    if (nameDataSet.includes(NAVIGATION_BUTTON_NAME)) {
      const buttonElement = target as HTMLButtonElement;
      articleContentNavigationButtonClickEvent({
        articleName,
        idArticle,
        sectionName,
        subsectionName,
        sectionId,
        subsectionId,
        blockName: buttonElement.innerText,
        helpCenterType,
        url,
      });

      return;
    }

    if (nameDataSet.includes(EArticleContentName.BROWSER_LINK)) {
      const linkElement = target as HTMLLinkElement;
      articleContentLinkClickEvent({
        articleName,
        idArticle,
        sectionName,
        subsectionName,
        sectionId,
        subsectionId,
        linkName: linkElement.innerText,
        linkUrl: linkElement.href,
        helpCenterType,
        url,
      });
    }

    if (nameDataSet.includes(EArticleContentName.EXPAND_PANEL)) {
      const isFaq = getIsTypeOfBlock({ parents, blockType: 'faq' });
      if (isFaq) {
        if (helpCenterType === EHelpCenterType.DRAWER) {
          drawerOpenFaqEvent({
            idFAQ: idArticle,
            faqName: target.textContent || '',
            helpCenterType,
            url,
          });

          return;
        }

        faqClickEvent({
          helpCenterType,
          sectionName,
          sectionId,
          subsectionId,
          subsectionName,
          questionName: target.innerText,
          url,
        });
      }
    }
  };
